"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newsletterGtmConfig = exports.getNewFormValidationSchema = exports.newFormInitialFormState = exports.formTypes = exports.newTypeFormConfig = void 0;
const SignUpFormConfig_1 = require("Views/Partials/Components/SignUp/SignUpFormConfig");
const yup = require("yup");
const Forms_1 = require("Forms");
exports.newTypeFormConfig = {
    rows: [
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.input,
                    className: SignUpFormConfig_1.formControlClasses.oneInARow,
                    key: SignUpFormConfig_1.formControlKeys.firstName,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.input,
                    className: SignUpFormConfig_1.formControlClasses.oneInARow,
                    key: SignUpFormConfig_1.formControlKeys.lastName,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.input,
                    className: SignUpFormConfig_1.formControlClasses.oneInARow,
                    key: SignUpFormConfig_1.formControlKeys.email,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.input,
                    className: SignUpFormConfig_1.formControlClasses.oneInARow,
                    key: SignUpFormConfig_1.formControlKeys.company,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.dropdown,
                    className: SignUpFormConfig_1.formControlClasses.oneInARow,
                    key: SignUpFormConfig_1.formControlKeys.country,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.checkbox,
                    className: `${SignUpFormConfig_1.formControlClasses.oneInARow} ${SignUpFormConfig_1.formControlClasses.agreementBlock}`,
                    key: SignUpFormConfig_1.formControlKeys.consentCheckbox,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.submit,
                    className: SignUpFormConfig_1.formControlClasses.oneInARow,
                    key: SignUpFormConfig_1.formControlKeys.submitBtn,
                },
            ],
        },
    ],
};
exports.formTypes = {
    newsletter: 'newsletter',
};
exports.newFormInitialFormState = {
    userType: 'B',
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    consentCheckbox: false,
    country: '',
    department: 'Corporate',
    jobFunction: 'Manager',
    companyType: 'Other',
};
const getNewFormValidationSchema = () => yup.object({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    email: yup
        .string()
        .email()
        .required()
        .test(value => !(0, Forms_1.validateInfoEmail)(value)),
    company: yup.string().required(),
    consentCheckbox: yup.boolean().oneOf([true], 'required').required(),
    country: yup.string().required(),
});
exports.getNewFormValidationSchema = getNewFormValidationSchema;
exports.newsletterGtmConfig = {
    title: 'Do you like to stay updated on the latest industry trends?',
    newsletterClass: 'newsletter-form newsletter-form-updated group',
    countryLabel: 'Country',
};
